import { Box, Button, Grid, IconButton, makeStyles, Paper, TextField, Typography } from "@material-ui/core";
import PlacePicker from "../components/PlacePicker";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { useEffect, useState } from "react";
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import LogoUpload from "../components/LogoUpload";
import { useInput } from "../utils/useInputHook";
import { addProviderInfo } from "../api/providerInfo";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/material.css'
import CircularProgress from '@material-ui/core/CircularProgress';
import formatLocation from "../utils/formatLocation";
import config from '../config';
import { useAlert } from "react-alert";
import React from 'react';
import { countries, countryToFlag } from '../api/countries';
import { States}  from "../api/states";
import { Close } from "@material-ui/icons";
import { SocialIcon } from 'react-social-icons';
import WebIcon from '@material-ui/icons/Web';
import { Fragment } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import RequestCategory from "./RequestCategory";

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1, 0),
        },
    },
    heading: {
        margin: theme.spacing(1, 0, 2, 0),
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex'
    },
    formControl: {
        width: '30%',
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(1),
    },
    preview: {
        width: 100,
        height: 100,
        borderRadius: 4,
        margin: theme.spacing(0.5)
    },
    previewWrapper: {
        position: 'relative',
        '&  .MuiIconButton-root': {
            position: 'absolute',
            top: '0',
            right: '0',
        }
    },
    phoneInput: {
        width: '100% !important',
        '&:focus': {
            borderColor: `${theme.palette.primary.main} !important`,
            boxShadow: `0 0 0 1px ${theme.palette.primary.main} !important`
        }
    },
    option: {
        fontSize: 15,
        '& > span': {
            marginRight: 10,
            fontSize: 18,
        },
    },
}));

const filter = createFilterOptions();
export default function AddProviderInfo({ providerInfo, onUpdate, categoryList, user, isAdmin, categoryTree, onCancel }) {
    const classes = useStyles();
    const alert = useAlert();
    const isEditForm = !!providerInfo._id;
    const [loading, setLoading] = useState(false);
    const { value: name, bind: bindName } = useInput(providerInfo?.info?.name || '');
    const { value: contact_email, bind: bindAccountEmail } = useInput(providerInfo?.info?.contact?.contact_email || '');
    const [data_source, setDatasource] = useState(providerInfo?.info?.data_source || 'London dataset');

    const [contact, setContact] = useState(providerInfo?.info?.contact?.contact_phone_number);
    const { value: contactName, bind: bindContactName } = useInput(providerInfo?.info?.contact?.contact_name || '');
    const { value: contactRole, bind: bindContactRole } = useInput(providerInfo?.info?.contact?.contact_role || '');

    const { value: description, bind: bindDescription } = useInput(providerInfo?.info?.description || '');
    const [logoFile, setlogoFile] = useState(providerInfo?.info?.logo_url || null);

    const [walk_in, setWalkIn] = useState(providerInfo?.info?.walk_in_flag || false);
    const [category, setCategory] = useState(categoryList.find(category => category._id === providerInfo?.info?.category?.id) || null);



    // const { value: licenseId, bind: bindLicenseId } = useInput(providerInfo?.info?.license || '');
    // const [licenseExpiry, setLicenseExpiry] = useState(providerInfo?.info?.license_expiry_date || null);

    const { value: addressLine1, bind: bindAddressLine1 } = useInput(providerInfo?.info?.address?.address_line_1 || '');
    const { value: street, bind: bindStreet } = useInput(providerInfo?.info?.address?.street || '');
    const { value: landmark, bind: bindLandmark } = useInput(providerInfo?.info?.address?.landmark || '');
    const { value: area, bind: bindArea } = useInput(providerInfo?.info?.address?.area || '');
    const { value: city, bind: bindCity } = useInput(providerInfo?.info?.address?.city || '');
    const [state, setStateValue] = useState(!!providerInfo?.info?.address?.state ? { name: providerInfo?.info?.address?.state } : {});
    const [country, setCountry] = useState(!!providerInfo?.info?.address?.country ? { label: providerInfo?.info?.address?.country } : {})
    const { value: zipCode, bind: bindZipCode } = useInput(providerInfo?.info?.address?.zip_code || '');
    const [location, setLocation] = useState(formatLocation(providerInfo?.adderss?.location));
    const [mapLoading, setMapLoading] = useState(false);

    const { value: website, bind: bindWebsite } = useInput(providerInfo?.info?.weblinks?.website || '');
    const { value: instagram, bind: bindInstagram } = useInput(providerInfo?.info?.weblinks?.instagram || '');
    const { value: whatsapp, bind: bindWhatsapp } = useInput(providerInfo?.info?.weblinks?.whatsapp || '');
    const { value: youtube, bind: bindYoutube } = useInput(providerInfo?.info?.weblinks?.youtube || '');
    const { value: facebook, bind: bindFacebook } = useInput(providerInfo?.info?.weblinks?.facebook || '');
    const { value: twitter, bind: bindTwitter } = useInput(providerInfo?.info?.weblinks?.twitter || '');
    const { value: email, bind: bindEmail } = useInput(providerInfo?.info?.weblinks?.email ||'');
    const { value: linkedin, bind: bindLinkedin } = useInput(providerInfo?.info?.weblinks?.linkedin ||'');

    const { value: notes, bind: bindNotes } = useInput(providerInfo?.info?.notes ||'');

    const [requestDialogActive, setRequestDialogActive] = useState(false);
    const [dialogValue, setDialogValue] = useState({ parent: '', name: '', description: '' });
    const setFilterStates = (label) => {
        const country =  countries.filter((d) => d.label == label);
        const filterStateData = States.filter((d) => (d.country_code === country[0].code));
        return filterStateData;
     };
    const [filterState, setFilterState] = useState(providerInfo?.info?.address?.country ? setFilterStates(providerInfo?.info?.address?.country): setFilterStates("United Kingdom"));

    const onCountryChange = (value) => {
        setCountry(value);
        filterStateFun(value.code);
        setStateValue({name:''});
      };

    const filterStateFun = (countryCode) => {
        const filterStateData = States.filter((d) => 
        (d.country_code === countryCode));
        setFilterState(filterStateData);
      };

    const handleCategoryRequest = (name) => {
        setDialogValue({ ...dialogValue, name })
        setRequestDialogActive(true)
    }

    const handleRequestFormClose = () => {
        setRequestDialogActive(false);
        setDialogValue({ parent: '', name: '', description: '' })
    }

    const onCategoryRequest = (data) => {
        setCategory({ _id: data.parent, id: data.parent, name: data.parent_name || data.name })
        handleRequestFormClose()
    }

    // const handleDateChange = (date) => {
    //     setLicenseExpiry(date);
    // };

    // const categoryListSorted = categoryList.sort((a, b) => (a?.vertical?.name > b?.vertical?.name) ? (a?.parent?.name > b?.parent?.name) ? (a.name > b.name) ? 1 : -1 : -1 : -1)


    useEffect(() => {
        setMapLoading(true);
        const delayed = setTimeout(async () => {
            console.log('stopped typing, checking location');
            try {
                const combined = [addressLine1, street, area, city, state, country?.label || ''].join(',');
                const defaultAddress = [
                    providerInfo.addressLine1,
                    providerInfo.street,
                    // providerInfo.landmark,
                    providerInfo.area,
                    providerInfo.city,
                    providerInfo.state,
                    providerInfo.country,
                    providerInfo.zip_code
                ].join(',');
                if (combined === defaultAddress) {
                    console.log('address same => setting to saved location')
                    setLocation(formatLocation(providerInfo?.info?.address?.location))
                    return;
                }
                if (combined.length < 5)
                    return;
                console.log(`Fetching new location`)
                const url = (`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(combined)}&key=${config.GOOGLE_MAPS_API_KEY}`);
                const req = await fetch(url);
                const data = await req.json();
                if (data.status === 'OK') {
                    const location = data.results[0].geometry.location;
                    console.log(`Locationfound`, location);
                    setLocation(location)
                } else {
                    console.log('no data?', data)
                    alert.show("Failed to convert address to location");
                }
            } catch (e) {
                console.log(e)
            } finally {
                setMapLoading(false);
            }
        }, 1000);
        return () => clearTimeout(delayed)

    }, [addressLine1, street, area, city, state, country, zipCode, providerInfo, alert])


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!name) {
            alert.show("Name is required");
            return;
        }
        if (!category?.name) {
            alert.show("Category is requried");
            return;
        }
        // if (!description) {
        //     alert.show("Description is required");
        //     return;
        // }
        // if (!contact) {
        //     alert.show("Contact number is required")
        //     return;
        // }
        // if (!addressLine1) {
        //     alert.show("Address line is requried");
        //     return;
        // }
        // if (!area) {
        //     alert.show("Area is required");
        //     return;
        // }
        // if (!state) {
        //     alert.show("State is requried");
        //     return;
        // }
        // if (!contactName) {
        //     alert.show("Contact name is required");
        //     return;
        // }
        // if (!contactRole) {
        //     alert.show("Contact role is required");
        //     return;
        // }
        // if (!!licenseExpiry && licenseExpiry < (new Date())) {
        //     alert.show("License can't have expiry date in past");
        //     return;
        // }
        const data = {
            name,
            data_source,
            contact_email,
            modified_by: user.email,
            description,
            logoFile,
            walk_in_flag: walk_in,
            category_name: category.name,
            category_id: category._id,
            // license: licenseId,
            // license_expiry_date: licenseExpiry,
            latitude: location?.lat,
            longitude: location?.lng,
            address_line_1: addressLine1,
            street,
            landmark,
            area,
            city,
            state: state.name,
            contact_name: contactName,
            contact_role: contactRole,
            contact_phone_number: contact,
            country: country.label,
            zipCode,
            website,
            whatsapp,
            instagram,
            youtube,
            facebook,
            twitter,
            email,
            linkedin,
            notes
        }
        try {
            setLoading(true);
            const res = await addProviderInfo(providerInfo._id, data, user.token)
            onUpdate({ ...res, user_id: providerInfo.user_id });
        } catch (e) {
            console.error('E', e);
            alert.show('Failed to update details')
        } finally {
            setLoading(false);
            onCancel();
        }
    }
    return (
        <Paper style={{ padding: '1em' }}>
            <Box className={classes.heading}>
                <Typography variant="h6" style={{ flex: '1' }}>
                    {isEditForm ? 'Edit Provider info' : 'Add Provider Info'}
                </Typography>
                <IconButton onClick={onCancel}>
                    <Close />
                </IconButton>
            </Box>

            <form className={classes.root} onSubmit={handleSubmit} style={{ padding: '2em' }}>

                <Grid container spacing={1}>
                    <Grid item xs={12} md={4}>
                        <TextField fullWidth label="Name *" variant="outlined" {...bindName} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField fullWidth label="Contact name" variant="outlined" {...bindContactName} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField fullWidth label="Contact Email" variant="outlined" {...bindAccountEmail} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Autocomplete fullWidth
                            options={['London dataset','2GIS', 'Google', 'Facebook', 'Instagram']}
                            autoHighlight
                            disableClearable
                            value={data_source}
                            onChange={(e, val) => setDatasource(val)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Data source"
                                    variant="outlined"

                                />
                            )}
                        />
                    </Grid>
                    
                    <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{"Mobile numbers: +44 followed by 10 numbers (0 excluded) \n Landline numbers: +44 followed by 10 numbers (0 excluded)"}</span>} placement="bottom-start">
                        <Grid item xs={12} md={4}>

                            <PhoneInput
                                enableSearch
                                value={contact}
                                containerStyle={{ margin: '8px 0' }}
                                inputClass={classes.phoneInput}
                                onChange={setContact}
                                specialLabel="Contact Number"
                                placeholder="+971 xxx xxx xxx"
                                country={'gb'}
                            />

                        </Grid>
                    </Tooltip>

                    <Grid item xs={12} md={4}>
                        <TextField fullWidth label="Contact role" variant="outlined" {...bindContactRole} />
                    </Grid>
                    {/* {!isAdmin && <>
                        <Grid item xs={6}>
                            <TextField fullWidth label="Email" variant="outlined" value={user.email} disabled />
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="caption" display="block" style={{ margin: 8 }} gutterBottom>
                                To update the email, please contact our support at <a rel="noreferrer" target="_blank" href="mailto:support@mazingday.com" style={{ color: '#0097a7' }}>support@mazingday.com</a> from the registered email
                                </Typography>
                        </Grid>
                    </>} */}
                    <Grid item xs={12} md={6}>
                        <TextField fullWidth label="Description" multiline rows={4}
                            style={{ margin: '8px 0' }}
                            variant="outlined" {...bindDescription} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <LogoUpload defaultImage={logoFile} onChange={setlogoFile} />
                    </Grid>
                    {/* <Grid item>
                        <FormControlLabel
                            label = 'Can people freely access your venue(s) anytime during opening hours?'
                            control={<Checkbox checked={walk_in}
                                onChange={async (event) => {
                                    setWalkIn(event.target.checked);
                                }} />}
                        />
                    </Grid> */}
                    <Grid item xs={12}>
                        <Autocomplete
                            id="category"
                            freeSolo
                            onChange={(event, newValue) => {
                                 // console.log(newValue)
                                 if (typeof newValue === 'string') {
                                    // timeout to avoid instant validation of the dialog's form.
                                    setTimeout(() => {
                                        handleCategoryRequest(newValue)
                                        setCategory({ name: newValue })
                                    });
                                } else if (newValue && newValue.inputValue) {
                                    handleCategoryRequest(newValue.inputValue)
                                    setCategory({ name: newValue.inputValue })
                                } else {
                                    setCategory(newValue);
                                }
                            }}
                            value={category}
                            options={categoryList}
                            filterOptions={(options, params) => {
                                const filtered = filter(options, params);

                                if (params.inputValue !== '') {
                                    filtered.push({
                                        inputValue: params.inputValue,
                                        name: `Not found, Request "${params.inputValue}" to be added`,
                                    });
                                }

                                return filtered;
                            }}
                            getOptionLabel={(option) => {
                                // e.g value selected with enter, right from the input
                                if (typeof option === 'string') {
                                    return option;
                                }
                                if (option.inputValue) {
                                    return option.inputValue;
                                }
                                return option.name || '';
                            }}
                            // renderOption={(option) => `.parent?.name && ' » ') || ''}${option.name}`}
                            renderOption={(option) => {
                                return (
                                    <React.Fragment>
                                        {!!option?.vertical?.name && option?.vertical?.name !== option?.parent?.name &&
                                            <Typography>{option?.vertical?.name + ' - '}</Typography>
                                        }
                                        {!!option?.parent?.name &&
                                            <Typography>{option.parent?.name === "Root" ? "" : option?.vertical?.name === option?.parent?.name ? option.parent?.name + ' - ' : "> " + option.parent?.name + ' - '}</Typography>
                                        }
                                        {option?.name !== "Root" &&
                                            <Typography style={{ fontWeight: 'bold', paddingRight: 8 }}> {option.parent?.name === "Root" ? option.name : "> " + option.name}</Typography>
                                        }
                                    </React.Fragment>
                                )
                            }}
                            renderInput={(params) => (
                                <TextField {...params} label="Category *" variant="outlined" />
                            )}
                        />
                    </Grid>
                    {/* <Grid item xs={12}>
                        <Typography variant="h6">Trade License Information</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField fullWidth label="Trade License ID" variant="outlined" {...bindLicenseId} />
                    </Grid>
                    <Grid item xs={6}>
                        <KeyboardDatePicker
                            fullWidth
                            minDate={new Date()}
                            minDateMessage="License can't have expiry date in past"
                            inputVariant="outlined"
                            variant="dialog"
                            format="dd/MM/yyyy"
                            label="Expiry date"
                            value={licenseExpiry}
                            onChange={handleDateChange}
                        />
                    </Grid> */}
                    <Grid item xs={12}>
                        <Typography variant="h6">Company Address</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField fullWidth label="Office No - Floor - Building Name" variant="outlined" {...bindAddressLine1} />
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <TextField fullWidth label="Street No - Street Name" variant="outlined" {...bindStreet} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth label="Landmark" variant="outlined" {...bindLandmark} />
                            </Grid>

                        </Grid>
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <TextField fullWidth label="Area" variant="outlined" {...bindArea} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth label="City" variant="outlined" {...bindCity} />
                            </Grid>

                        </Grid>
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                {/* <TextField fullWidth label="State *" variant="outlined" {...bindState} /> */}
                                <Autocomplete fullWidth
                                    id="State"
                                    options={filterState}
                                    autoHighlight
                                    classes={{
                                        option: classes.option,
                                    }}
                                    getOptionLabel={(option) => option.name}
                                    disableClearable
                                    value={state}
                                    renderOption={(option) => (
                                        <Fragment>
                                            {option.name}
                                        </Fragment>
                                    )}
                                    onChange={(e, val) => setStateValue(val)}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="State"
                                            variant="outlined"

                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <Autocomplete
                                    id="country-select"
                                    options={countries}
                                    classes={{
                                        option: classes.option,
                                    }}
                                    autoHighlight
                                    disableClearable
                                    getOptionLabel={(option) => option.label}
                                    value={country}
                                    onChange={(e, option) => onCountryChange(option)}
                                    renderOption={(option) => (
                                        <Fragment>
                                            <span>{countryToFlag(option.code)}</span>
                                            {option.label} ({option.code})
                                        </Fragment>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            fullWidth
                                            label="Country"
                                            variant="outlined"
                                            inputProps={{
                                                ...params.inputProps,
                                                autoComplete: 'new-password', // disable autocomplete and autofill
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth label="Postcode" variant="outlined" {...bindZipCode} />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} md={6} style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                        <PlacePicker
                            initialLocation={formatLocation(providerInfo.location) || null}
                            loading={mapLoading}
                            location={location}
                            onChange={setLocation} />
                    </Grid>

                    <Grid item xs={12} style={{marginTop:'15px'}}>
                        <Typography variant="h6">Online Presence</Typography>
                    </Grid>


                    <Grid item xs={12} md={6}>
                        <Grid container spacing={1} style={{ alignItems: 'flex-end', marginLeft: 3, marginRight: 3 }}>
                            <Grid item >
                                <WebIcon style={{ fontSize: 40 }} />
                            </Grid>
                            <Grid item xs>
                                <TextField fullWidth id="standard-basic" label="Website"  {...bindWebsite} />
                            </Grid>
                        </Grid>

                        <Grid container spacing={1} style={{ alignItems: 'flex-end', marginLeft: 3, marginRight: 3 }}>
                            <Grid item >
                                <SocialIcon network="instagram" style={{ height: 40, width: 40 }} />
                            </Grid>
                            <Grid item xs>
                                <TextField fullWidth id="standard-basic" label="Instagram"  {...bindInstagram} />
                            </Grid>
                        </Grid>
                        <Tooltip title="Please enter the general WhatsApp number for the company (not for a specific branch). This WhatsApp number should be available for the public.">
                        <Grid container spacing={1} style={{ alignItems: 'flex-end', marginLeft: 3, marginRight: 3 }}>
                            <Grid item >
                                <SocialIcon network="whatsapp" style={{ height: 40, width: 40 }} />
                            </Grid>
                            <Grid item xs>
                                <TextField fullWidth id="standard-basic" label="Whatsapp"  {...bindWhatsapp} />
                            </Grid>
                        </Grid>
                        </Tooltip>
                        <Grid container spacing={1} style={{ alignItems: 'flex-end', marginLeft: 3, marginRight: 3 }}>
                            <Grid item >
                                <SocialIcon network="linkedin" style={{ height: 40, width: 40 }} />
                            </Grid>
                            <Grid item xs>
                                <TextField fullWidth id="standard-basic" label="LinkedIn"  {...bindLinkedin} />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Tooltip title="Please enter the general email address for the company (not for a specific branch). This email address should be available for the public.">
                        <Grid container spacing={1} style={{ alignItems: 'flex-end', marginLeft: 3, marginRight: 3 }}>
                            <Grid item >
                                <SocialIcon network="email" style={{ height: 40, width: 40 }} />
                            </Grid>
                            <Grid item xs>
                                <TextField fullWidth id="standard-basic" label="Email"  {...bindEmail} />
                            </Grid>
                        </Grid>
                        </Tooltip>
                        <Grid container spacing={1} style={{ alignItems: 'flex-end', marginLeft: 3, marginRight: 3 }}>
                            <Grid item >
                                <SocialIcon network="youtube" style={{ height: 40, width: 40 }} />
                            </Grid>
                            <Grid item xs>
                                <TextField fullWidth id="standard-basic" label="Youtube"  {...bindYoutube} />
                            </Grid>
                        </Grid>

                        <Grid container spacing={1} style={{ alignItems: 'flex-end', marginLeft: 3, marginRight: 3 }}>
                            <Grid item >
                                <SocialIcon network="facebook" style={{ height: 40, width: 40 }} />
                            </Grid>
                            <Grid item xs>
                                <TextField fullWidth id="standard-basic" label="Facebook"  {...bindFacebook} />
                            </Grid>
                        </Grid>

                        <Grid container spacing={1} style={{ alignItems: 'flex-end', marginLeft: 3, marginRight: 3 }}>
                            <Grid item >
                                <SocialIcon network="twitter" style={{ height: 40, width: 40 }} />
                            </Grid>
                            <Grid item xs>
                                <TextField fullWidth id="standard-basic" label="Twitter" {...bindTwitter} />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} style={{marginTop:'15px'}}>
                        <Typography variant="h6" style={{ flex: '1'}}>Notes</Typography>
                    </Grid>
                    <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{"Please use this field if there is any additional information from the provider"}</span>} placement="bottom-start">
                        <Grid item xs={12} >
                            <TextField fullWidth multiline rows={4} label="Additional information" variant="outlined" {...bindNotes} />
                        </Grid>
                    </Tooltip>


                    <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
                        <Button variant="contained" type="submit" color="primary" disabled={loading}>
                            {loading ? <CircularProgress color="inherit" className={classes.circularProgress} size={20} /> : 'Save'}
                        </Button>
                    </Grid>
                </Grid>
            </form>
            <RequestCategory
                dialogValue={dialogValue}
                setDialogValue={setDialogValue}
                user={user}
                providerId={providerInfo._id}
                categoryTree={categoryTree}
                open={requestDialogActive}
                handleRequest={onCategoryRequest}
                handleClose={handleRequestFormClose} />
        </Paper >

    );
}
